import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";

import { post } from "../../utils/io";
import PasswordVerification from "../Auth/PasswordVerification";

function NewOrgConfirmation() {
  const history = useHistory();
  const location = useLocation();
  const token = location.hash.substring(1);

  const [input, setInput] = useState({
    password: "",
    confirmPassword: "",
  });

  const [isPasswordError, setIsPasswordError] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [isRequesting, setIsRequesting] = useState(false);
  const [isInvalidToken, setIsInvalidToken] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const setPassword = (value) =>
    setInput((pre) => ({ ...pre, password: value }));

  const setConfirmPassword = (value) =>
    setInput((pre) => ({ ...pre, confirmPassword: value }));

  useEffect(() => {
    setIsLoading(true);
    async function tokenVerified() {
      const res = await post(`/org_requests/verify_token`, {
        confirmation_token: token,
      });
      if (res.status !== 204) {
        setIsInvalidToken(true);
      }
      setIsLoading(false);
    }
    tokenVerified();
  }, [token]);

  const isButtonDisabled = () =>
    isRequesting ||
    !input.confirmPassword ||
    !input.password ||
    input.password !== input.confirmPassword ||
    isPasswordError;

  const onSubmitForm = async () => {
    setIsRequesting(true);
    setErrMessage("");

    try {
      const payload = {
        password: input.password,
        confirmation_token: token,
      };
      const response = await post("/org_requests/complete_request", payload);
      setIsRequesting(false);
      if (response.status !== 204) {
        return setErrMessage("Failed to complete organization request.");
      }
      history.push("/");
    } catch (error) {
      setErrMessage("Failed to complete organization request.");
      setIsRequesting(false);
    }
    return null;
  };
  return (
    <Grid
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {isLoading && <CircularProgress />}
      {!isLoading && isInvalidToken && (
        <Box
          sx={{
            background: "#d3d3d347",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h2>Your confirmation link has expired</h2>
          <p>Check your email for a new confirmation link.</p>
        </Box>
      )}
      {!isLoading && !isInvalidToken && (
        <Box
          sx={{
            border: `1px solid ${grey[300]}`,
            padding: "15px",
            borderRadius: "4px",
            maxWidth: 400,
          }}
        >
          <h3>Select a password</h3>
          <PasswordVerification
            password={input.password}
            setPassword={setPassword}
            confirmPassword={input.confirmPassword}
            setConfirmPassword={setConfirmPassword}
            setError={setIsPasswordError}
          />
          {errMessage && (
            <Typography
              variant="body2"
              sx={{
                color: red[500],
                fontStyle: "italic",
                textAlign: "center",
                marginTop: 0,
              }}
            >
              {errMessage}
            </Typography>
          )}
          <Button
            onClick={onSubmitForm}
            variant="contained"
            color="primary"
            sx={{
              width: "100%",
            }}
            disabled={isButtonDisabled()}
          >
            {isRequesting && (
              <CircularProgress
                size={16}
                sx={{
                  marginRight: "10px",
                }}
              />
            )}{" "}
            Submit
          </Button>
        </Box>
      )}
    </Grid>
  );
}

export default NewOrgConfirmation;
